import UtilsSchema from "@repoflow/schema/utils";

import {
  captureId,
  eventType,
  timestamp,
  ext,
  size,
  totalSize,
  derivedFileSize,
  derivedFileCount,
  dimensions,
  measures,
} from "./fields";

export default [
  ...UtilsSchema,
  // The faithful shape, kept so the arrays have somewhere to be described. It is
  // not rendered anywhere — see the projection below for why.
  {
    id: "/Public/Capture",
    type: "object",
    properties: {
      captureId,
      eventType,
      timestamp,
      dimensions,
      measures,
    },
  },
  // The read-only projection the table actually renders, and the reason it
  // exists:
  //
  // `namedValue.value` is typed `["string", "number", "boolean"]`, because a
  // measure's type is decided by the point rather than the capture. A widget
  // resolver picking one renderer for that union settles on the boolean, so
  // every dimension and measure value rendered as the literal "true" — names
  // correct, values gone. datum hit this first and recorded it in
  // projects/datum-repoflow/common/schema/capture/public.js; a row count would
  // not have noticed either time.
  //
  // datum fixed it by flattening both arrays to text — "bucketId=b1, ext=pdf" —
  // because a point owner's table has to render a capture from ANY point.
  // bucketws can do better: it knows this point declares orgId/bucketId/ext and
  // four numeric measures, so it flattens to NAMED TYPED columns. Those sort,
  // right-align and format as bytes; a text blob does none of that.
  //
  // The flattening itself lives in components/statistics/format.js, which the
  // per-bucket screen and the organization dashboard both draw from.
  {
    id: "/Public/Capture/Listing",
    type: "object",
    properties: {
      timestamp,
      eventType,
      ext,
      size,
      totalSize,
      derivedFileSize,
      derivedFileCount,
      captureId,
    },
  },
  // There is deliberately no /Public/Capture/Create. bucketws WRITES captures —
  // from its upload, unzip, minimap and remove handlers — but never from client
  // input: the handlers build the payload themselves from a stored file row.
  // Adding a create projection here would suggest an inbound shape that does not
  // exist.
];
